module.exports = __webpack_public_path__ + "img/DK31593336.67206e4f.png";